<template>
    <div>
        <rednax-datatable
            :url="'/vue/products?mode=supplierlist'"
            :columns="table_columns"
            :filter="table_filter"
            @updateFilter="table_filter=$event"
            history
            size="md"
            :per-page="1000"
            sort-by="ProdName"
            sort-order="asc"
            :row-class="getRowClass"
        >
            <div class="row">
                <div class="col-lg-3">
                    <input type="text" v-model="table_filter.search" class="form-control">
                </div>
                <div class="col-auto" style="width: 240px;">
                    <v-select
                        v-model="table_filter.is_struct"
                        :options="status_options.map((opt) => ({ id: opt.id, label: opt.label + ' Strukturartiklar' }))"
                        placeholder="-- Strukturartiklar --"
                        :reduce="(opt) => opt.id"
                    ></v-select>
                </div>
                <div class="col-auto" style="width: 220px;">
                    <v-select
                        v-model="table_filter.is_out_of_stock"
                        :options="status_options.map((opt) => ({ id: opt.id, label: opt.label + ' Tillfälligt slut' }))"
                        placeholder="-- Tillfälligt slut --"
                        :reduce="(opt) => opt.id"
                    ></v-select>
                </div>
                <div class="col-auto" style="width: 200px;">
                    <v-select
                        v-model="table_filter.no_refill"
                        :options="status_options.map((opt) => ({ id: opt.id, label: opt.label + ' Ej Refill' }))"
                        placeholder="-- Ej Refill --"
                        :reduce="(opt) => opt.id"
                    ></v-select>
                </div>
                <div class="col-auto" style="width: 250px;">
                    <v-date-picker
                        v-model="date"
                        mode="date"
                        :locale="{ id: 'sv', firstDayOfWeek: 2, masks: { weekdays: 'WW', input: 'YYYY-MM-DD' } }"
                        :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
                        is-range
                        show-iso-weeknumbers
                    >
                        <template v-slot="{ inputValue, togglePopover }">
                            <div class="input-group">
                                <span class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="icon-calendar2"></i>
                                    </span>
                                </span>
                                <input
                                    class="form-control"
                                    :value="(inputValue.start && inputValue.end ? inputValue.start + ' - ' + inputValue.end : '')"
                                    @focus="togglePopover()"
                                    placeholder="Datumintervall..."
                                />
                            </div>
                        </template>
                    </v-date-picker>
                </div>
            </div>
            <template #cell_ProdID="{ row }">
                <router-link :to="{ name: 'products.edit', params: { id: row.ProdID } }">{{ row.ProdID }}</router-link><MarkedProductIndicator :prod-id="row.ProdID" />
            </template>
            <template #cell_images="{ row }">
                <div v-if="row.images && row.images.length > 0">
                    <img :id="`product-image-${row.ProdID}`" :src="row.images[0].urls['small']" :alt="row.ProdID" style="height: 60px; margin: -8px 0;">
<!--                    <div v-if="row.images.length > 1" style="margin-top: 8px; margin-bottom: -8px;">{{ row.images.length }} bilder i popup</div>-->
                    <b-popover :target="`product-image-${row.ProdID}`" triggers="hover">
                        <img :src="row.images[0].urls['medium']" :alt="row.ProdID" style="width: 100%;">
                    </b-popover>
                </div>
            </template>
            <template #cell_isPhasedOut="{ row }">
                <div v-if="row.isStruct" class="badge badge-info">STRUKTURARTIKEL</div>
                <div v-if="row.isHiddenFromAllCards" class="badge badge-purple">GÖMD FRÅN KORT</div>
                <div v-else-if="row.show_on_all_cards" class="badge badge-warning">VISAS PÅ ALLA KORT</div>
                <div v-if="row.isPhasedOut === 1" class="badge badge-danger">HAR UTGÅTT</div>
                <div v-else>
                    <div v-if="row.isNonStockItem" class="badge badge-warning">Beställningsvara</div>
                    <div v-if="row.isOutOfStock === 1">
                        <div class="badge badge-danger">TILLF. SLUT</div>
                        <div v-if="row.BackInStockDate && row.BackInStockDate != '0000-00-00'">Åter {{ row.BackInStockDate }}</div>
                        <div v-else-if="row.no_refill" class="badge badge-purple">EJ REFILL</div>
                        <div v-else-if="row.autoblockfunction === 'isPhasedOut'" class="badge badge-warning">UTGÅENDE</div>
                    </div>
                    <div v-else-if="row.no_refill" class="badge badge-purple">EJ REFILL</div>
                    <div v-else-if="row.autoblockfunction === 'isPhasedOut'" class="badge badge-warning">UTGÅENDE</div>
                </div>
            </template>
            <template #cell_ProdName="{ row }">
                <router-link :to="{ name: 'products.edit', params: { id: row.ProdID } }">{{ row.ProdName }}</router-link><span class="text-muted" v-if="row.SupplierPackageSize > 0"> ({{ row.SupplierPackageSize }}/fp)</span>
            </template>
            <template #cell_ReorderingPoint="{ row }">
                <div class="text-right">{{ row.ReorderingPoint }}</div>
            </template>
            <template #cell_form="{ row }">
                <input v-if="!row.isStruct" type="number" min="0" step="1" class="form-control" v-model="form.products[row.ProdID]">
            </template>
            <template #cell_purchases="{ row }">
                <div class="d-flex justify-content-between">
                    <div style="width: 40px; text-align: right;">{{ row['redeemed'] }}</div>
                    <i :id="`stat-${row.ProdID}`" class="icon-history d-block"></i>
                    <b-popover :target="`stat-${row.ProdID}`" triggers="hover">
                        <div v-for="i in 5" :key="'stat-' + row.ProdID + '-' + (current_year + 2 - parseInt(i, 10))">
                            Nov{{ (current_year - i).toString().substring(2) }}-Nov{{ (current_year - i + 1).toString().substring(2) }}: {{ row['redeemed_' + (current_year - i) + '_' + (current_year - i + 1)] }}
                        </div>
                    </b-popover>
                </div>
            </template>
        </rednax-datatable>
        <div class="text-right">
            <limitless-button ref="btncreatepurchase" :busy="busy_creating_purchase" @click="createPurchase">Skapa beställning</limitless-button>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import { mapState } from 'pinia';
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import { useAuthStore } from '@services/pinia/AuthStore';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';

export default {
    name: 'SupplierEditorProducts',
    components: {
        VDatePicker,
        vSelect,
        LimitlessButton,
        RednaxDatatable,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    created() {
        this.table_filter.supplier_id = this.id;
    },
    mounted() {
        const end = new Date();
        const start = new Date();
        start.setFullYear(start.getFullYear() - 1);
        start.setMonth(10);
        start.setDate(1);
        this.date = {
            start: start.toISOString().substring(0, 10),
            end: end.toISOString().substring(0, 10),
        };
    },
    data: () => ({
        busy_creating_purchase: false,
        form: {
            products: {},
        },
        date: null,
        table_filter: {
            search: '',
            supplier_id: null,
            is_phased_out: 0,
            is_struct: null,
            is_out_of_stock: null,
            no_refill: null,
            date_start: null,
            date_end: null,
        },
        status_options: [
            {
                id: null,
                label: 'Inkl. ',
            },
            {
                id: 1,
                label: 'Endast',
            },
            {
                id: 0,
                label: 'Dölj',
            },
        ],
    }),
    watch: {
        date: {
            deep: true,
            handler(date) {
                if (date) {
                    // eslint-disable-next-line prefer-destructuring
                    this.table_filter.date_start = date.start;
                    // eslint-disable-next-line prefer-destructuring
                    this.table_filter.date_end = date.end;
                } else {
                    this.table_filter.date_start = null;
                    this.table_filter.date_end = null;
                }
            },
        },
    },
    methods: {
        getRowClass(row) {
            const arr = [];
            if (row.isPhasedOut === 1) {
                arr.push('bg-danger-200');
                arr.push('text-line-through');
            } else if (row.isOutOfStock === 1) {
                arr.push('bg-yellow-200');
            }
            if (row.isStruct === 1) {
                arr.push('font-weight-bold');
            }
            return arr;
        },
        async createPurchase() {
            this.busy_creating_purchase = true;
            const purchase = {
                ProdSupplierID: this.id,
                UserID: this.user.id,
                items: [],
                StatusID: 0,
                AddressID: 1,
            };
            Object.entries(this.form.products).forEach(([key, value]) => {
                if (parseInt(value, 10) > 0) {
                    purchase.items.push({
                        ProdID: key,
                        Antal: value,
                        Typ: 1,
                    });
                }
            });

            if (purchase.items.length > 0) {
                await apiClient.post('/vue/suppliers/purchases/0', purchase)
                    .then((response) => {
                        window.location.href = '/suppliers/purchases/' + response.data.purchase.ProdPurchaseID;
                    }).catch(() => {
                        this.$refs.btncreatepurchase.triggerFailed();
                    }).finally(() => {
                        this.busy_creating_purchase = false;
                    });
            } else {
                this.$swal({
                    icon: 'warning',
                    title: 'Inga produkter!',
                    text: 'Beställningen måste innehålla produkter',
                    reverseButtons: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Avbryt',
                });
            }
            this.busy_creating_purchase = false;
        },
        formatDateString(dateString) {
            const date = new Date(dateString);

            const day = date.getDate().toString();
            const month = (date.getMonth() + 1).toString();
            const year = date.getFullYear().toString().slice(-2);

            return `${day}/${month}-${year}`;
        },
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
        current_year() {
            const date = new Date();
            return parseInt(date.getFullYear(), 10);
        },
        table_columns() {
            return [
                {
                    header: '#',
                    data: 'ProdID',
                    sortable: true,
                },
                {
                    header: 'Bild',
                    data: 'images',
                    sortable: false,
                },
                {
                    header: 'Produkt',
                    data: 'ProdName',
                    sortable: true,
                },
                {
                    header: 'Lev. Artnr.',
                    data: 'ProdSupplierSKU',
                    sortable: true,
                },
                {
                    header: 'Status',
                    data: 'isPhasedOut',
                    sortable: false,
                },
                {
                    header: 'Lagersaldo',
                    data: 'Stock_today',
                    sortable: true,
                    align_right: true,
                },
                {
                    header: 'På order',
                    data: 'order',
                    sortable: false,
                    align_right: true,
                    render(row) {
                        return row.Stock_today - row.Stock_future;
                    },
                },
                {
                    header: 'Disponibelt',
                    data: 'Stock_future',
                    sortable: true,
                    align_right: true,
                },
                {
                    header: 'Best. punkt',
                    data: 'ReorderingPoint',
                    sortable: true,
                    align_right: true,
                    class(row) {
                        return (row.Stock_future <= row.ReorderingPoint ? 'bg-danger-300' : '');
                    },
                },
                {
                    header: 'Beställt',
                    data: 'ordered_total',
                    sortable: true,
                    align_right: true,
                },
                {
                    header: 'Best. datum',
                    data: 'ordered_date',
                    sortable: true,
                    render(row) {
                        return (row.ordered_date ? row.ordered_date.substring(0, 12) : '');
                    },
                },
                {
                    header: 'Beställ',
                    data: 'form',
                    sortable: true,
                },
                {
                    header: 'Inlöst ' + this.formatDateString(this.table_filter.date_start) + '-' + this.formatDateString(this.table_filter.date_end),
                    data: 'redeemed',
                    sortable: false,
                },
            ];
        },
    },
};

</script>
